import * as Types from '../../../../_types/serverTypes';

import { useQuery, UseQueryOptions } from 'react-query';
import { fetcher } from 'src/clients/graphql/idr';
export type PermissionsQueryVariables = Types.Exact<{
  data?: Types.InputMaybe<Types.InputQueryFilter_ResourcePermissionReqDto>;
}>;


export type PermissionsQuery = { __typename?: 'Queries', resourceQueries?: { __typename?: 'ResourceQueries', permissions?: { __typename?: 'Response_ResourcePermissionResDto', isSuccess?: boolean | null | undefined, listDto?: { __typename?: 'List_ResourcePermissionResDto', items?: Array<{ __typename?: 'Output_ResourcePermissionResDto', resource?: { __typename?: 'Output_ResourceDto', id: string, parentId?: string | null | undefined, title?: string | null | undefined, value?: string | null | undefined, hasChild: boolean } | null | undefined } | null | undefined> | null | undefined } | null | undefined } | null | undefined } | null | undefined };


export const PermissionsDocument = `
    query permissions($data: InputQueryFilter_ResourcePermissionReqDto) {
  resourceQueries {
    permissions(filter: $data) {
      isSuccess
      listDto {
        items {
          resource {
            id
            parentId
            title
            value
            hasChild
          }
        }
      }
    }
  }
}
    `;
export const usePermissionsQuery = <
      TData = PermissionsQuery,
      TError = unknown
    >(
      variables?: PermissionsQueryVariables,
      options?: UseQueryOptions<PermissionsQuery, TError, TData>
    ) =>
    useQuery<PermissionsQuery, TError, TData>(
      variables === undefined ? ['permissions'] : ['permissions', variables],
      fetcher<PermissionsQuery, PermissionsQueryVariables>(PermissionsDocument, variables),
      options
    );